import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Modal } from 'bootstrap';
import branchDetailStyles from "../../../styles/userDetails/branchDetails.module.css";

import { MultiSelect } from 'primereact/multiselect';
import { ToggleButton } from 'primereact/togglebutton';
import { Message } from 'primereact/message';
import Loader from '../../loader/index.js';

import postalCodesByBranchClient from '../../../utility/features/api_clients/appointment/getPostalCodeByBranch'
import editBranchDetailsClient from '../../../utility/features/api_clients/appointment/editBranchDetails'
import updateBranchStatusClient from '../../../utility/features/api_clients/appointment/updateBranchStatus'
import './appointment.css';
function EditBranchDetailsModal({ branchDetails, setLoading, setSuccessMessage,setErrorMessage, openSuccessModal, openFailureModal, handleUpdateSlotsClick, setIsBranchEdited }) {
    const editBranchDetailsRef = useRef(null);
    const messageRef = useRef(null);
    const zipMultiSelectRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [branchDetailsEdit, setBranchDetailsEdit] = useState(null);
    const [selectedZip, setSelectedZip] = useState([]);
    const [branchAction, setBranchAction] = useState("");
    const [checked, setChecked] = useState(false);
    const [fetchError, setFetchError] = useState("");
    const [postalCodes, setPostalCodes] = useState([]);
    const [updatedStatus, setUpdatedStatus] = useState('');

    const fetchPostalCode = async () => {
        try {
            const result = await postalCodesByBranchClient(branchDetails?.branchID);
            if (result ?.status !== 200) {
                setFetchError("Postal code data fetch failed. Please try again.");
                return;
            }

            const { status, data } = result ?? {};
            if (status === 200 && data?.messageCode !== 20000) {
                // normalize API response which may be an array or wrapped in an object
                const items = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
                const options = items.map(item => ({
                    name: item.postalCodeID ? String(item.postalCodeID) : '',
                    postalCodeID: item.postalCodeID,
                    isActive: item.isActive
                }));

                setPostalCodes(options);
            } else if (data?.messageCode === 20000) {
                setFetchError(data.message || "No postal codes available for the selected branch.");
                setPostalCodes([]);
                console.log("Error calling postal code data api :", data.message);
            } else {
                setFetchError(data.message || "Unexpected response from server.");
            }
        }
        catch (err) {
            console.error("Error logging in:", err);
        }
    }

    useEffect(() => {
        if (branchDetails) {
            setTimeout(() => {
                setBranchDetailsEdit(branchDetails);
                setChecked(branchDetails.isBranchEnabled);
            }, 10);

            // get postal codes by branch
            (async () => {
                await fetchPostalCode();
            })();
        } else {
            setBranchDetailsEdit(null);
        }
    }, [branchDetails]);

    const toggleAction = (e) => {
        setIsLoading(true);
        setChecked(e.target.value);
        const updateBranchStatus = async () => {
            let reqBody = {
                "branchID": branchDetails?.branchID,
                "branchName": branchDetails?.branchName,
                "isActive": e.target.value === "true"
            }
            
            try {
                const resp = await updateBranchStatusClient(reqBody);
                
                if (resp?.data.messageCode == 20000) {
                    setFetchError(resp?.data.message);
                } else if (resp.status === 200) {
                    setIsBranchEdited(prev => !prev);
                    setUpdatedStatus('Status updated successfully!');
                } else {
                    setFetchError(resp.message || "Unexpected response from server.");
                }
            } catch (err) {
                console.log("Error fetching user details:", err);
            }
            setIsLoading(false);
        }
        updateBranchStatus();
    }

    const handleResetForm = () => {
        setSelectedZip([]);
        setBranchAction("");

        editBranchDetailsRef.current.querySelector(".invalid-postalcode-req").classList.remove("show");
        editBranchDetailsRef.current.querySelector(".invalid-action-req").classList.remove("show");
    }

    const editBranchFormSubmit = async (event) => {
        event.preventDefault();

        if ((!branchAction || branchAction === "default") && (selectedZip.length == 0 )) { 
            editBranchDetailsRef.current.querySelector(".invalid-postalcode-req").classList.add("show");
            editBranchDetailsRef.current.querySelector(".invalid-action-req").classList.add("show");
        } else if (!branchAction || branchAction === "default") {
            editBranchDetailsRef.current.querySelector(".invalid-postalcode-req").classList.remove("show");
            editBranchDetailsRef.current.querySelector(".invalid-action-req").classList.add("show");
        } else if (selectedZip.length == 0) {
            editBranchDetailsRef.current.querySelector(".invalid-postalcode-req").classList.add("show");
            editBranchDetailsRef.current.querySelector(".invalid-action-req").classList.remove("show");
        } else {
            editBranchDetailsRef.current.querySelector(".invalid-postalcode-req").classList.remove("show");
            editBranchDetailsRef.current.querySelector(".invalid-action-req").classList.remove("show");

            let reqBody = {
                branchID: branchDetailsEdit?.branchID,
                postalCodeID: selectedZip,
                isActive: branchAction === "true"
            };
    
            setLoading(true);
            editBranchDetailsClient(reqBody).then((result) => {
                if (result.status === 200 && result.data.messageCode === 200) {
                    openSuccessModal();
                    setSuccessMessage("PostalCode update successful.");
    
                    handleResetForm();
    
                    setTimeout(() => {
                        const el = document.getElementById('editBranchModal');
                        if (el) {
                            const instance = Modal.getOrCreateInstance(el);
                            instance.hide();
                        }
                    }, 100);
    
                    // Hide any open modals
                    document.querySelectorAll('.modal.show').forEach((el) => {
                        const instance = Modal.getOrCreateInstance(el);
                        instance.hide();
                    });
    
                    document.body.classList.remove('modal-open');
                    document.querySelectorAll('.modal-backdrop').forEach((bd) => bd.remove());
                    document.querySelectorAll(".modal-backdrop").forEach(el => el.classList.remove("modal-backdrop"));
                    document.querySelector("body").classList.remove("modal-open");
                    document.querySelector("body").style = "";
                    (async () => {
                        await fetchPostalCode();
                    })();
                }
                else {
                    setTimeout(() => {
                        const el = document.getElementById('editBranchModal');
                        if (el) {
                            const instance = Modal.getOrCreateInstance(el);
                            instance.hide();
                        }
                    }, 100);

                    setErrorMessage(result.data.message)
                    openFailureModal();
                }
            });
        }
        
        setLoading(false);
    }

    useEffect(() => { 
        const timer = setTimeout(() => { 
            if (updatedStatus !== '' || fetchError !== '') {
                setUpdatedStatus('');
                setFetchError('');
            }
        }, 5000);
        
        return () => clearTimeout(timer); // cleanup
    }, [updatedStatus, fetchError]);

    useEffect(() => {
        const modalElement = document.getElementById('editBranchModal');
        if (modalElement) {
            // Prevent modal from closing on backdrop click
            modalElement.addEventListener('hide.bs.modal', function (event) {
                const isCloseButton = event.target.querySelector('.btn-close:focus');
                const isDismissButton = document.activeElement.hasAttribute('data-bs-dismiss');
                handleResetForm();
                // Only allow closing via close button or programmatically
                if (!isCloseButton && !isDismissButton && event.target === modalElement) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            });
        }
        
        return () => {
            if (modalElement) {
                modalElement.removeEventListener('hide.bs.modal', function() {});
            }
        };
    }, []);     

    useEffect(() => {
        const handleDocumentClick = (event) => {
            const target = event.target;
            if (!(target instanceof Element)) return;

            const clickedInsideMultiSelect = target.closest('.p-multiselect') || target.closest('.p-multiselect-panel');
            if (!clickedInsideMultiSelect) {
                zipMultiSelectRef.current?.hide?.();
            }
        };

        // Use capture so it still fires even if inner elements stopPropagation (e.g., modal-content)
        document.addEventListener('click', handleDocumentClick, true);
        return () => document.removeEventListener('click', handleDocumentClick, true);
    }, []);

    // Custom template for MultiSelect options
    const zipItemTemplate = (option) => {
        const isInactive = option.isActive === false;
        const style = isInactive
            ? {
                background: '#833AB4',
                background: 'linear-gradient(90deg,rgba(131, 58, 180, 1) 0%, rgba(253, 29, 29, 1) 0%, rgba(252, 176, 69, 1) 100%)',
                color: '#fff',
                borderRadius: '4px',
                padding: '4px 8px',
                margin: '2px 0',
            }
            : {};
        return (
            <div style={style}>{option.name}</div>
        );
    };

    return (
        <>
        {isLoading && <Loader />}
            <div className={`modal fade `} id="editBranchModal" tabIndex="-1" aria-labelledby="editBranchModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className={`modal-dialog`}>
                    <div className={`modal-content`} onClick={(e) => e.stopPropagation()}>
                        <div className={`modal-header`}>
                            <h5 id="editBranchModalLabel" className={`modal-title`}>Update {branchDetails && branchDetailsEdit?.branchName} Branch({branchDetailsEdit?.branchID})</h5>
                            <button type="button" className={`btn-close`} data-bs-dismiss="modal" aria-label="Close"/>
                        </div>
                        <div className={`modal-body`}>
                            <div className='row py-2'>
                            {updatedStatus ? <Message ref={messageRef} severity="success" text="Status updated successfully!" /> : fetchError ? <Message  ref={messageRef} severity="error" text="Error updating status!" /> : ''}                            
                                <div className='d-flex'>
                                <div className='col-6 margin-auto'>
                                    <div className={`${branchDetailStyles['branch-details']}`}>
                                        <h6>Branch Status Update </h6>
                                    </div>
                                  </div>  
                                  <div className='col-6'>
                                        <select class="form-select" aria-label="Select Action"
                                            value={checked} onChange={toggleAction}>
                                            <option value='true'>Active</option>
                                            <option value='false'>In Active</option>
                                        </select>
                                  </div>
                                </div>
                            </div>
                            <hr/>
                            <div className='d-flex'>
                                <div className='col-7 margin-auto'>
                                    <h6>Click to Update slots of the Branch:</h6>
                                </div>
                                <div className='col-5 text-align-end'>
                                    <button
                                        type="button"
                                        className={`btn btn-info ${branchDetailStyles['update-btn']}`}
                                        data-bs-dismiss="modal"
                                        onClick={() => handleUpdateSlotsClick(branchDetails)}
                                    >
                                        Update Slots
                                        </button>
                                </div>                  
                            </div>
                            <hr/>
                            <div className='row mb-10'>
                                <h5>{branchDetailsEdit?.branchName} Postalcode Action</h5>
                            </div>
                            <form
                                ref={editBranchDetailsRef}
                                className='ShowLoadingModal form-horizontal'
                                role='form'
                                noValidate='novalidate'
                                name='editBranchModal'
                            >
                                <div className='row'>
                                    <div className='col-6 pr-7'>
                                        <div className={`${branchDetailStyles['update-zip-info']}`}>
                                        <div className={`invalid-postalcode-req invalid-feedback`}>Please select any Postal Code</div>
                                        <MultiSelect
                                            ref={zipMultiSelectRef}
                                            value={selectedZip}
                                            onChange={(e) => setSelectedZip(e.value)}
                                            options={postalCodes}
                                            optionLabel="name"
                                            optionValue="postalCodeID"
                                            placeholder="Select Postal Codes"
                                            maxSelectedLabels={3}
                                            className="w-full md:w-20rem"
                                            style={{ maxHeight: '38px', display: 'flex', alignItems: 'center' }}
                                            showSelectAll={true}
                                            selectAllLabel="Select All"
                                            itemTemplate={zipItemTemplate}
                                            // panelStyle={{ maxHeight: '200px' }}
                                        />
                                        </div>
                                   </div>   
                                   <div className='col-6 pl-7'>  
                                        <div className={`${branchDetailStyles['update-zip-info']}`}>
                                        <div className={`invalid-action-req invalid-feedback`}>Please select an action</div>
                                            <select class="form-select" aria-label="Default select example"
                                            value={branchAction} onChange={(e) => setBranchAction(e.target.value)}>
                                                <option selected value="default">Select Action</option>
                                                <option value="true">Enable</option>
                                                <option value="false">Disable</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='text-align-end mt-10'>
                                <button
                                    type="button"
                                    className={`btn btn-info ${branchDetailStyles['update-zip-btn']}`}
                                    onClick={(e) => editBranchFormSubmit(e)}
                                >
                                    Update
                                </button>
                               </div> 
                            </form>
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditBranchDetailsModal;